
import { createRouter, createWebHistory } from 'vue-router';


const routes = [
  {
    path: '/about',
    name: 'about',
    component: () => import('../components/About.vue'),
  },
  {
    path: '/buymokit',
    name: 'buymokit',
    component: () => import('../components/BuyMOKIT.vue'),
  },{
    path: '/stakemokit',
    name: 'stakemokit',
    component: () => import('../components/Stake.vue'),
  },{
    path: '/mokitgame',
    name: 'mokitgame',
    component: () => import('../components/MokitGame.vue'),
  },{
    path: '/whitepaper',
    name: 'whitepaper',
    component: () => import('../components/WhitePaper.vue'),
  }
  ,{
    path: '/mokitchart',
    name: 'mokitchart',
    component: () => import('../components/MokitChart.vue'),
  }
  ,{
    path: '/mokitburn',
    name: 'mokitburn',
    component: () => import('../components/MokitBurn.vue'),
  }
  ,{
    path: '/:pathMatch(.*)*',
    redirect: '/about',  // Redirect to the About page for any unknown routes
  },
  
  
  

];


const router = createRouter({
  history: createWebHistory(),
  routes,
});


export default router;

